export default __webpack_public_path__ + "static/media/agronav-img.c7d73159.png";